module.exports = __webpack_public_path__ + "static/userLogin-49d970dcc4edbc52474d0ddcfabd180d.gif";